<template>
    <div class="panel-body">
        <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
        
        <!-- Controles de Carga Masiva -->
        <div class="row mb-4">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header bg-primary text-white">
                        <h5 class="mb-0">Gestión de Autorizaciones - Carga Masiva</h5>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <h6>Descargar Plantillas</h6>
                                <button class="btn btn-success me-2 mb-2" @click="descargarPlantilla('finalizada')">
                                    <i class="bi bi-download"></i> Plantilla Autorizaciones Finalizadas
                                </button>
                                <button class="btn btn-warning mb-2" @click="descargarPlantilla('retirada')">
                                    <i class="bi bi-download"></i> Plantilla Retiro de Autorizaciones
                                </button>
                            </div>
                            <div class="col-md-6">
                                <h6>Cargar Archivo</h6>
                                <div class="mb-3">
                                    <label class="form-label">Tipo de Autorización:</label>
                                    <select v-model="tipoAutorizacionCarga" class="form-select">
                                        <option value="">Seleccionar...</option>
                                        <option value="finalizada">Autorización Finalizada</option>
                                        <option value="retirada">Retiro de Autorización</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <input 
                                        type="file" 
                                        ref="archivoInput" 
                                        class="form-control" 
                                        accept=".xlsx,.xls,.csv"
                                        @change="seleccionarArchivo"
                                    >
                                </div>
                                <button 
                                    class="btn btn-primary" 
                                    @click="cargarExcel"
                                    :disabled="!archivoSeleccionado || !tipoAutorizacionCarga || cargando"
                                >
                                    <span v-if="cargando" class="spinner-border spinner-border-sm me-2"></span>
                                    {{ cargando ? 'Procesando...' : 'Cargar y Procesar Excel' }}
                                </button>
                            </div>
                        </div>
                        
                        <!-- Resultados de carga masiva -->
                        <div v-if="resultadoCarga" class="mt-4">
                            <div :class="['alert', resultadoCarga.fallidos === 0 ? 'alert-success' : 'alert-warning']">
                                <h6>Resultado del Proceso:</h6>
                                <ul class="mb-0">
                                    <li>Total de registros: {{ resultadoCarga.total }}</li>
                                    <li class="text-success">Exitosos: {{ resultadoCarga.exitosos }}</li>
                                    <li class="text-danger">Fallidos: {{ resultadoCarga.fallidos }}</li>
                                </ul>
                            </div>
                            
                            <!-- Detalles de errores -->
                            <div v-if="resultadoCarga.fallidos > 0" class="mt-3">
                                <h6>Detalles de Errores:</h6>
                                <div class="table-responsive">
                                    <table class="table table-sm table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Fila</th>
                                                <th>N° Solicitud</th>
                                                <th>Error</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="error in resultadoCarga.detalles.fallidos" :key="error.fila">
                                                <td>{{ error.fila }}</td>
                                                <td>{{ error.id_solicitud }}</td>
                                                <td class="text-danger">{{ error.error }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Filtros de Autorización -->
        <div class="row mb-3">
            <div class="col-md-4">
                <label class="form-label"><strong>Filtrar por Estado de Autorización:</strong></label>
                <select v-model="filtroEstadoAutorizacion" class="form-select" @change="aplicarFiltroAutorizacion">
                    <option value="">Todas las solicitudes</option>
                    <option value="sin_autorizacion">Sin autorización</option>
                    <option value="finalizada">Autorización finalizada</option>
                    <option value="retirada">Autorización retirada</option>
                </select>
            </div>
            <div class="col-md-2 d-flex align-items-end">
                <b-button variant="info" size="sm" @click="cargarEstadosAutorizacion">
                    🔄 Recargar Estados
                </b-button>
            </div>
        </div>

        <!-- Tabla de Solicitudes -->
        <TableGeneral 
            ref="tablaAutorizaciones"
            :optionst="options" 
            :optionss="optionss" 
            :fields="fields" 
            :requiereListas="requiereListas" 
            :requiereDescarga="requiereDescarga" 
            :condicionFiltrao="condicionFiltrao" 
            :cliente="cliente" 
            :editar="editable"
            :opcionAutorizar="opcionAutorizar"
            :requiereAutorizar="requiereAutorizar"
            :carpeta="carpeta" 
            :typeOrder="typeOrder"
            :condicionales="condicionales"
            @autorizarSolicitud="mostrarModalAutorizacion"
            @datos-cargados="cargarEstadosAutorizacion"
        ></TableGeneral>

        <!-- Modal para Autorización Individual -->
        <b-modal ref="modalAutorizacion" title="Registrar Autorización" hide-footer centered>
            <div class="modal-body">
                <div class="mb-3">
                    <label class="form-label">Solicitud N°:</label>
                    <input type="text" class="form-control" :value="solicitudSeleccionada?.['N°Solicitud'] || solicitudSeleccionada?.id" disabled>
                </div>
                <div class="mb-3">
                    <label class="form-label">Paciente:</label>
                    <input type="text" class="form-control" :value="solicitudSeleccionada?.Paciente || solicitudSeleccionada?.paciente || 'N/A'" disabled>
                </div>
                <div class="mb-3">
                    <label class="form-label">Tipo de Autorización: <span class="text-danger">*</span></label>
                    <select v-model="autorizacionForm.tipo" class="form-select">
                        <option value="">Seleccionar...</option>
                        <option value="finalizada">Autorización Finalizada</option>
                        <option value="retirada">Retiro de Autorización</option>
                    </select>
                </div>
                <div class="mb-3">
                    <label class="form-label">Observaciones:</label>
                    <textarea v-model="autorizacionForm.observaciones" class="form-control" rows="3"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <b-button variant="secondary" @click="cerrarModal">Cancelar</b-button>
                <b-button 
                    variant="primary" 
                    @click="registrarAutorizacion"
                    :disabled="!autorizacionForm.tipo || guardando"
                >
                    <b-spinner small v-if="guardando"></b-spinner>
                    {{ guardando ? 'Guardando...' : 'Guardar Autorización' }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue';
import VueFormGenerator from 'vue-form-generator';
import 'vue-form-generator/dist/vfg.css';
import TableGeneral from "../../components/Table.vue";
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import "vue-form-generator/dist/vfg-core.css";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';

Vue.use(VueFormGenerator);

const autorizaciones = RepositoryFactory.get("autorizaciones");

export default {
    components: {
        "vue-form-generator": VueFormGenerator.component,
        TableGeneral,
        HeaderGeneral
    },
    data() {
        return {
            typeOrder: "desc",
            carpeta: "Aseguradores",
            vista: "Gestión de Autorizaciones",
            proveniente: " - Gestión de Autorizaciones",
            requiereListas: true,
            requiereDescarga: true,
            condicionFiltrao: "todas",
            editable: 0,
            cliente: 1,
            opcionAutorizar: true,
            requiereAutorizar: true,
            
            // Opciones de filtros
            options: [
                { value: null, text: 'Seleccionar' },
                { value: 'id', text: 'Número de solicitud' },
                { value: 'documento', text: 'Documento' },
                { value: 'nombre_completo', text: 'Paciente' },
                { value: 'departamento', text: 'Departamento' },
                { value: 'estado', text: 'Estado' }
            ],
            
            optionss: [
                { value: null, text: 'Seleccionar' },
                { value: '1', text: 'Nuevo' },
                { value: '3', text: 'En solicitud' },
                { value: '5', text: 'Solicitud tomada' },
                { value: '6', text: 'Proceso de entrega' },
                { value: '7', text: 'Entregado' },
                { value: '8', text: 'Fallo de entrega' },
                { value: '12', text: 'Segundo intento de entrega' },
                { value: '2', text: 'Rechazado' },
                { value: '10', text: 'Finalizado' },
                { value: '11', text: 'Cancelado' },
            ],
            
            fields: [
                { key: 'N°Solicitud', sortable: true },
                { key: 'Fecha solicitud', sortable: true },
                { key: 'T.Documento', sortable: true },
                { key: 'Documento', sortable: true },
                { key: 'Paciente', sortable: true },
                { key: 'Cliente', sortable: true },
                { key: 'Proveedor', sortable: true },
                { key: 'Estado', sortable: true },
                { key: 'Estado Autorización', sortable: true },
                'Acciones'
            ],
            
            condicionales: {
                "AND": [
                    {
                        "estado": {
                            "notEquals": "0"
                        }
                    }
                ]
            },
            
            // Carga masiva
            archivoSeleccionado: null,
            tipoAutorizacionCarga: '',
            cargando: false,
            resultadoCarga: null,
            
            // Autorización individual
            solicitudSeleccionada: null,
            autorizacionForm: {
                tipo: '',
                observaciones: ''
            },
            guardando: false,
            
            // Filtro de estado de autorización
            filtroEstadoAutorizacion: '',
            itemsOriginales: null
        };
    },
    methods: {
        /**
         * Aplicar filtro de estado de autorización (filtrado local)
         */
        aplicarFiltroAutorizacion() {
            const tabla = this.$refs.tablaAutorizaciones;
            if (!tabla || !this.itemsOriginales) {
                return;
            }
            
            // Filtrar según selección
            let itemsFiltrados = [...this.itemsOriginales];
            
            if (this.filtroEstadoAutorizacion === 'sin_autorizacion') {
                itemsFiltrados = itemsFiltrados.filter(item => !item['Estado Autorización'] || item['Estado Autorización'] === '');
            } else if (this.filtroEstadoAutorizacion === 'finalizada') {
                itemsFiltrados = itemsFiltrados.filter(item => item['Estado Autorización'] === 'Autorización finalizada');
            } else if (this.filtroEstadoAutorizacion === 'retirada') {
                itemsFiltrados = itemsFiltrados.filter(item => item['Estado Autorización'] === 'Autorización retirada');
            }
            // Si está vacío '', mostrar todos
            
            // Actualizar items de la tabla
            tabla.items = itemsFiltrados;
        },

        /**
         * Descargar plantilla Excel según tipo de autorización
         */
        descargarPlantilla(tipo) {
            autorizaciones.descargarPlantilla(tipo);
            this.$bvToast.toast('Plantilla descargada exitosamente', {
                title: 'Éxito',
                variant: 'success',
                solid: true
            });
        },

        /**
         * Validar y seleccionar archivo Excel
         */
        seleccionarArchivo(event) {
            const archivo = event.target.files[0];
            
            if (!archivo) {
                return;
            }
            
            // Validar extensión
            const extension = archivo.name.split('.').pop().toLowerCase();
            if (!['xlsx', 'xls', 'csv'].includes(extension)) {
                this.$bvToast.toast('Formato no válido. Use archivos .xlsx, .xls o .csv', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
                this.$refs.archivoInput.value = '';
                this.archivoSeleccionado = null;
                return;
            }
            
            // Validar tamaño (5MB)
            if (archivo.size > 5 * 1024 * 1024) {
                this.$bvToast.toast('El archivo no debe superar 5MB', {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
                this.$refs.archivoInput.value = '';
                this.archivoSeleccionado = null;
                return;
            }
            
            this.archivoSeleccionado = archivo;
        },

        /**
         * Cargar y procesar archivo Excel (parsea en el navegador)
         */
        async cargarExcel() {
            if (!this.archivoSeleccionado || !this.tipoAutorizacionCarga) {
                this.$bvToast.toast('Debe seleccionar un archivo y el tipo de autorización', {
                    title: 'Advertencia',
                    variant: 'warning',
                    solid: true
                });
                return;
            }
            
            this.cargando = true;
            this.resultadoCarga = null;
            
            try {
                // Leer y parsear el Excel en el navegador
                const datosExcel = await this.leerArchivoExcel(this.archivoSeleccionado);
                
                console.log('Datos leídos del Excel:', datosExcel);
                
                // Debugging: Ver qué columnas tiene realmente el primer registro
                if (datosExcel && datosExcel.length > 0) {
                    console.log('Columnas disponibles:', Object.keys(datosExcel[0]));
                    console.log('Primer registro completo:', datosExcel[0]);
                }
                
                // Validar que haya datos
                if (!datosExcel || datosExcel.length === 0) {
                    throw new Error('El archivo está vacío o no tiene datos');
                }
                
                // Mapear y validar los registros
                const registros = [];
                const errores = [];
                
                datosExcel.forEach((row, index) => {
                    const numeroFila = index + 2; // +2 porque row 1 es header
                    
                    try {
                        // Buscar el ID de solicitud de forma flexible (con o sin caracteres especiales)
                        const idSolicitud = row['id_solicitud'] || row['N°Solicitud'] || row['NSolicitud'] || 
                                          row['Numero Solicitud'] || row['numero_solicitud'] || 
                                          Object.values(row)[0]; // Si todo falla, toma la primera columna
                        const observaciones = row['observaciones'] || row['Observaciones'] || 
                                            Object.values(row)[1] || ''; // Si falla, toma segunda columna
                        
                        if (!idSolicitud || isNaN(parseInt(idSolicitud))) {
                            const columnasDisponibles = Object.keys(row).join(', ');
                            errores.push(`Fila ${numeroFila}: ID de solicitud no válido o faltante. Columnas disponibles: ${columnasDisponibles}`);
                            return;
                        }
                        
                        registros.push({
                            id_solicitud: parseInt(idSolicitud),
                            observaciones: observaciones
                        });
                    } catch (error) {
                        errores.push(`Fila ${numeroFila}: ${error.message}`);
                    }
                });
                
                // Mostrar errores si los hay
                if (errores.length > 0) {
                    console.warn('Errores de validación:', errores);
                    this.$bvToast.toast(`Se encontraron ${errores.length} errores de validación. Ver consola para detalles.`, {
                        title: 'Advertencia',
                        variant: 'warning',
                        solid: true,
                        autoHideDelay: 5000
                    });
                }
                
                // Si no hay registros válidos, abortar
                if (registros.length === 0) {
                    throw new Error('No se encontraron registros válidos para procesar');
                }
                
                console.log(`Registros válidos a enviar: ${registros.length}`);
                
                // Enviar al backend
                const response = await autorizaciones.cargaMasivaAutorizaciones({
                    registros: registros,
                    tipo_autorizacion: this.tipoAutorizacionCarga
                });
                
                if (response.status === 200) {
                    const datos = response.data;
                    this.resultadoCarga = datos;
                    
                    if (datos.fallidos === 0) {
                        this.$bvToast.toast(`${datos.exitosos} registros procesados exitosamente`, {
                            title: '✅ Carga Completada',
                            variant: 'success',
                            solid: true
                        });
                    } else {
                        this.$bvToast.toast(`${datos.exitosos} exitosos, ${datos.fallidos} fallidos`, {
                            title: '⚠️ Carga Completada con Errores',
                            variant: 'warning',
                            solid: true
                        });
                        
                        // Mostrar errores del backend
                        if (datos.errores && datos.errores.length > 0) {
                            console.error('Errores del backend:', datos.errores);
                            let mensajeErrores = `Errores al procesar:\n\n`;
                            datos.errores.slice(0, 10).forEach((error, idx) => {
                                mensajeErrores += `${idx + 1}. ${error}\n`;
                            });
                            if (datos.errores.length > 10) {
                                mensajeErrores += `\n... y ${datos.errores.length - 10} errores más.`;
                            }
                            
                            Swal.fire({
                                icon: 'warning',
                                title: `Errores (${datos.fallidos})`,
                                text: mensajeErrores,
                                confirmButtonText: 'Entendido'
                            });
                        }
                    }
                    
                    // Limpiar formulario
                    this.$refs.archivoInput.value = '';
                    this.archivoSeleccionado = null;
                    this.tipoAutorizacionCarga = '';
                    
                    // Recargar tabla y estados de autorización
                    if (this.$refs.tablaAutorizaciones && this.$refs.tablaAutorizaciones.misSolicitudes) {
                        await this.$refs.tablaAutorizaciones.misSolicitudes();
                        await this.cargarEstadosAutorizacion();
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al Procesar Archivo',
                        text: 'No se pudo procesar el archivo Excel',
                        confirmButtonText: 'Entendido'
                    });
                }
            } catch (error) {
                console.error('Error en carga masiva:', error);
                const mensajeError = error.response?.data?.error?.message || error.message || 'Error al procesar la carga masiva';
                Swal.fire({
                    icon: 'error',
                    title: 'Error en Carga Masiva',
                    text: mensajeError,
                    confirmButtonText: 'Entendido'
                });
            } finally {
                this.cargando = false;
            }
        },
        
        /**
         * Leer archivo Excel usando XLSX
         */
        leerArchivoExcel(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                
                reader.onload = (e) => {
                    try {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        
                        // Leer la primera hoja
                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];
                        
                        // Convertir a JSON
                        const jsonData = XLSX.utils.sheet_to_json(worksheet);
                        resolve(jsonData);
                    } catch (error) {
                        reject(error);
                    }
                };
                
                reader.onerror = (error) => reject(error);
                reader.readAsArrayBuffer(file);
            });
        },
        
        /**
         * Mostrar modal de autorización individual
         */
        mostrarModalAutorizacion(solicitud) {
            this.solicitudSeleccionada = solicitud;
            this.autorizacionForm = {
                tipo: '',
                observaciones: ''
            };
            
            this.$refs.modalAutorizacion.show();
        },
        
        /**
         * Cerrar modal de autorización
         */
        cerrarModal() {
            this.$refs.modalAutorizacion.hide();
            this.solicitudSeleccionada = null;
            this.autorizacionForm = { tipo: '', observaciones: '' };
        },
        
        /**
         * Registrar autorización individual
         */
        async registrarAutorizacion() {
            if (!this.autorizacionForm.tipo) {
                this.$bvToast.toast('Debe seleccionar el tipo de autorización', {
                    title: 'Advertencia',
                    variant: 'warning',
                    solid: true
                });
                return;
            }
            
            this.guardando = true;
            
            try {
                const datos = {
                    id_solicitud: this.solicitudSeleccionada['N°Solicitud'] || this.solicitudSeleccionada.id,
                    tipo_autorizacion: this.autorizacionForm.tipo,
                    observaciones: this.autorizacionForm.observaciones
                };
                
                const response = await autorizaciones.registrarAutorizacion(datos);
                
                if (response.status === 200) {
                    this.$bvToast.toast('Autorización registrada exitosamente', {
                        title: '✅ Éxito',
                        variant: 'success',
                        solid: true
                    });
                    
                    // Resetear estado guardando ANTES de cerrar modal
                    this.guardando = false;
                    
                    // Cerrar modal
                    this.$refs.modalAutorizacion.hide();
                    
                    // Limpiar formulario
                    this.solicitudSeleccionada = null;
                    this.autorizacionForm = { tipo: '', observaciones: '' };
                    
                    // Recargar tabla y estados en segundo plano
                    this.$nextTick(async () => {
                        if (this.$refs.tablaAutorizaciones && this.$refs.tablaAutorizaciones.misSolicitudes) {
                            await this.$refs.tablaAutorizaciones.misSolicitudes();
                        }
                    });
                } else {
                    // Respuesta no exitosa (otros códigos de estado)
                    let mensajeError = 'Error al registrar la autorización';
                    
                    if (response.data?.error) {
                        const errorData = response.data.error;
                        if (errorData.detail) {
                            mensajeError = errorData.detail;
                        } else if (errorData.message) {
                            mensajeError = errorData.message;
                        }
                    }
                    
                    // Mostrar error con SweetAlert
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al Registrar',
                        text: mensajeError,
                        confirmButtonText: 'Entendido'
                    });
                    
                    this.guardando = false;
                    
                    // Cerrar modal incluso con error
                    this.$refs.modalAutorizacion.hide();
                    this.solicitudSeleccionada = null;
                    this.autorizacionForm = { tipo: '', observaciones: '' };
                }
            } catch (error) {
                console.error('Error al registrar autorización:', error);
                
                // Extraer mensaje de error específico del backend
                let mensajeError = 'Error al registrar la autorización';
                
                if (error.response?.data?.error) {
                    const errorData = error.response.data.error;
                    // Si hay detail, usar ese (es más específico)
                    if (errorData.detail) {
                        mensajeError = errorData.detail;
                    } else if (errorData.message) {
                        mensajeError = errorData.message;
                    }
                }
                
                // Mostrar error con SweetAlert
                Swal.fire({
                    icon: 'error',
                    title: 'Error al Registrar',
                    text: mensajeError,
                    confirmButtonText: 'Entendido'
                });
                
                this.guardando = false;
                
                // Cerrar modal incluso con error
                this.$refs.modalAutorizacion.hide();
                this.solicitudSeleccionada = null;
                this.autorizacionForm = { tipo: '', observaciones: '' };
            }
        },

        /**
         * Cargar estados de autorización para los items de la tabla
         */
        async cargarEstadosAutorizacion() {
            try {
                const tabla = this.$refs.tablaAutorizaciones;
                if (!tabla || !tabla.items || tabla.items.length === 0) {
                    return;
                }

                const items = tabla.items;
                
                // Extraer solo los IDs de las solicitudes visibles en la tabla
                const idsVisibles = items
                    .map(item => item['N°Solicitud'] || item['N° solicitud'] || item.id)
                    .filter(id => id);

                if (idsVisibles.length === 0) {
                    return;
                }

                // Obtener solo las autorizaciones de las solicitudes visibles
                const response = await autorizaciones.obtenerSolicitudes({ ids: idsVisibles });
                
                if (response.status === 200 && response.data) {
                    // Crear un mapa de id_solicitud -> descripción de autorización
                    const mapaAutorizaciones = {};
                    response.data.forEach(sol => {
                        if (sol.estado_autorizacion && sol.tipo_autorizacion) {
                            // Generar descripción según el tipo
                            let descripcion = '';
                            if (sol.tipo_autorizacion === 'finalizada') {
                                descripcion = 'Autorización finalizada';
                            } else if (sol.tipo_autorizacion === 'retirada') {
                                descripcion = 'Autorización retirada';
                            } else {
                                descripcion = sol.estado_autorizacion;
                            }
                            mapaAutorizaciones[sol.id] = descripcion;
                        }
                    });

                    // Actualizar los items de la tabla con el estado de autorización
                    items.forEach(item => {
                        const idSolicitud = item['N°Solicitud'] || item['N° solicitud'] || item.id;
                        
                        if (idSolicitud && mapaAutorizaciones[idSolicitud]) {
                            this.$set(item, 'Estado Autorización', mapaAutorizaciones[idSolicitud]);
                        } else {
                            this.$set(item, 'Estado Autorización', '');
                        }
                    });
                    
                    // Guardar items originales para filtrado
                    this.itemsOriginales = [...items];
                    
                    // Si hay un filtro activo, aplicarlo
                    if (this.filtroEstadoAutorizacion) {
                        await this.aplicarFiltroAutorizacion();
                    }
                }
            } catch (error) {
                console.error('Error al cargar estados de autorización:', error);
            }
        }
    },
    
    mounted() {
        // Los estados se cargarán automáticamente cuando la tabla emita el evento 'datos-cargados'
    }
};
</script>

<style scoped>
.card {
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.spinner-border-sm {
    width: 1rem;
    height: 1rem;
    border-width: 0.2em;
}
</style>
